<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps({
    genre: {
        type: String,
        default: '',
    },
})

const router = useRouter()

const id = computed(() => props.genre.toLowerCase().replace(/ /g, '_'))

function goToGenre() {
    router.push({ name: 'genre', params: { id: id.value } })
}
</script>

<template>
    <BaseButton
        button-type="tagSecondary"
        size="small"
        @click="goToGenre"
    >
        <slot>
            {{ genre }}
        </slot>
    </BaseButton>
</template>
